import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"error\"><defs><style></style></defs><path d=\"M768 694.818L694.818 768 512 585.114 329.114 768 256 694.818 438.818 512 256 329.114 329.114 256 512 438.852 694.818 256 768 329.114 585.182 512 768 694.818zM512 0C229.205 0 0 229.205 0 512c0 282.726 229.205 512 512 512 282.726 0 512-229.274 512-512C1024 229.205 794.726 0 512 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id